import Swal from "sweetalert2";
import { useNavigate } from "react-router-dom"; 
import Config from "../API/Config";

const useLogout = () => {
    const navigate = useNavigate();

    const handleLogout = () => {
        Swal.fire({
            title: "Are you sure?",
            text: "You will be logged out from your account.",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Yes, Logout",
        }).then((result) => {
            if (result.isConfirmed) {
                sessionStorage.clear();
                Config.clearUserSession();
                Swal.fire("Logged Out!", "You have been logged out.", "success");
                navigate("/");
            }
        });
    };

    return handleLogout;
};

export default useLogout;
